import styled from '@emotion/styled';

export const LoadingContent = styled.div`
  position: absolute;

  div {
    svg {
      width: 20px;
    }
  }
`;

